import React from 'react';

import classNames from 'classnames';

import { bubEvents } from 'javascripts/shared/events/bub_events';

import { ReactComponent as CondensedIcon } from 'images/condensed-format.svg';
import { ReactComponent as DetailedIcon } from 'images/detailed-format.svg';

import styles from 'stylesheets/components/deals/format_buttons.module';

import PropTypes from 'prop-types';

export function FormatButtons({ format, hideBackground, onFormatChange }) {
  function changeFormat(newFormat) {
    bubEvents.track('Changed display', 'Clicked button', {
      label: 'Applied display',
      value: newFormat,
    });
    onFormatChange(newFormat);
  }

  function renderCondensedIcon() {
    return <CondensedIcon className={styles.condensedIcon} alt='' />;
  }

  function renderDetailedIcon() {
    return <DetailedIcon className={styles.detailedIcon} alt='' />;
  }

  return (
    <div className={styles.dealsFormatButtons}>
      <button
        className={classNames(styles.detailedOption, { [styles.noBackground]: hideBackground })}
        onClick={() => changeFormat('detailed')}
        onTouchEnd={() => changeFormat('detailed')}
        disabled={format === 'detailed'}
        aria-label='Detailed View'
        title='Detailed View'
      >
        {renderDetailedIcon()}
      </button>
      <button
        className={classNames(styles.condensedOption, { [styles.noBackground]: hideBackground })}
        onClick={() => changeFormat('condensed')}
        onTouchEnd={() => changeFormat('condensed')}
        disabled={format === 'condensed'}
        aria-label='Condensed View'
        title='Condensed View'
      >
        {renderCondensedIcon()}
      </button>
    </div>
  );
}

FormatButtons.propTypes = {
  format: PropTypes.oneOf(['detailed', 'condensed']).isRequired,
  hideBackground: PropTypes.bool,
  onFormatChange: PropTypes.func,
};

FormatButtons.defaultProps = {
  hideBackground: false,
};
